export const reportTypes = [
    "RP",
    "RW",
    "WA",
    "IA",
    "AC",
    "IV",
    "BA",
    "UV",
    "IG",
    "UB",
    "PN",
    "NR",
    "IB",
    "II",
    "IC",
    "MB",
    "HW",
    "TT",
    "SK"
];
